<span [innerHTML]="value"></span>
